import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";

import OfficeStatusTable from "./view/OfficeStatusTable";

export const OfficeStatus = () => {
  const viewStatus =
     PERMISSIONS.permission_utilities_officeconfiguration_officestatus_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return <>{userPermissions.includes(viewStatus) && <OfficeStatusTable />}</>;
};

export default OfficeStatus;
